import {bindActionCreators} from "redux"
import TemplateView from '../../TemplateView'
import LoadingMoire from '../../LoadingMoire'
import $ from 'jquery'
import _ from 'underscore'
import TaskStore from '../../store/TaskStore'
import TaskRow from './TaskRow'
import {connect} from "../../redux/utils"
import {
    getEditableCustomerIds,
    getEditableProjectIds,
    getManageableTaskIds,
    getSingleCPSelection,
    getTaskCustomFieldsMap,
    isNeedToShowSelection
} from '../common/selectors'
import {getArchivedCustomerIds, getArchivedProjectIds, getShownColumnsWithOrder} from './selectors'
import StringTokenizer from '../../util/StringTokenizer'
import TokensHighlighter from '../../util/TokensHighlighter'
import {openEditTaskPanel} from '../../panels/task/editPanel/actions'
import {isBTYEnabled, isESTEnabled, isTWSEnabled} from '../../features/selectors'
import {canEditHierarchy, canGenerateMoneyReports} from '../../loggedInUser/selectors'
import {TypeOfWorkMenu} from '../../controls/task/TypeOfWorkMenu'
import TaskStatusMenu from '../../controls/task/TaskStatusMenu'
import {updateTaskCustomField} from './actions'
import DropdownOptionsMenu from './customFields/DropdownOptionsMenu'

export class TaskRowsTableContent extends TemplateView {
    constructor({
        openTaskPanel = () => {},
        afterWidthChanged = () => {},
        updateTaskCustomField = () => {},
    }) {
        super()

        this.actions = {
            openTaskPanel,
            updateTaskCustomField,
        }

        this.callbacks = {
            afterWidthChanged,
        }

        this.state = {
            manageableTaskIds: {},
            archivedProjectIds: {},
            archivedCustomerIds: {},
            editableProjectIds: {},
            editableCustomerIds: {},
            showSelection: false,
            columnsOrder: [],
            isTWSEnabled: false,
            isBTYEnabled: false,
            isESTEnabled: false,
            canEditHierarchy: false,
            canGenerateMoneyReports: false,
            customFields: {}
        }

        this.onAnyStatePropertyChanged(['manageableTaskIds', 'showSelection', 'editableProjectIds',
                                        'editableCustomerIds', 'archivedProjectIds', 'archivedCustomerIds',
                                        'canEditHierarchy', 'canGenerateMoneyReports', 'customFields'], () => {
            this._updateTaskRowsState()
        })

        this.onStatePropertyChanged('isTWSEnabled', (isTWSEnabled) => {
            Object.values(this.taskRows).forEach((row) => row.setState({isTWSEnabled}))
        })

        this.onStatePropertyChanged('isBTYEnabled', (isBTYEnabled) => {
            Object.values(this.taskRows).forEach((row) => row.setState({isBTYEnabled}))
        })

        this.onStatePropertyChanged('isESTEnabled', (isESTEnabled) => {
            Object.values(this.taskRows).forEach((row) => row.setState({isESTEnabled}))
        })

        this.onStatePropertyChanged('columnsOrder', (columnsOrder) => {
            Object.values(this.taskRows).forEach((row) => row.setState({columnsOrder}))
            this.callbacks.afterWidthChanged()
        })

        this.taskRows = {}
        this.stringTokenizer = null
        this.tokensHighligter = null
    }


    templateHtml() {
        return "<div class='taskRowsTableContent'>" +
               "    <div class='tasksTablesWrapper'>" +
               "        <div class='createdTasksTableContainer'>" +
               "            <table class='createdTasksRowsTable' cellpadding='0' cellspacing='0'></table>" +
               "        </div>" +
               "        <div class='taskRowsTableContainer'>" +
               "            <table class='taskRowsTable' cellpadding='0' cellspacing='0'></table>" +
               "        </div>" +
               "    </div>" +
               "    <div class='loadingIndicatorContainer'></div>" +
               "</div>"
    }

    afterRender() {
        this.$taskRowsTable = this.find('.taskRowsTable')
        this.$createdTaskRowsTable = this.find('.createdTasksRowsTable')

        this.appendLoadingMoire = new LoadingMoire({
            additionalSpinnerSettings: {},
            showAnimated: false,
            hideAnimated: false,
        }).init(this.find('.loadingIndicatorContainer'))
        this.reloadLoadingMoire = new LoadingMoire().init(this.$containerEl)

        $(document).on("taskManagement_task_startEditing", (e, taskId) => {
            const taskRow = this.taskRows[taskId]
            if (taskRow) {
                taskRow.startEditing()
            }
        })

        $(document).on("taskManagement_task_stopEditing", (e, taskId) => {
            const taskRow = this.taskRows[taskId]
            if (taskRow) {
                taskRow.stopEditing()
            }
        })

        $(document).on("taskManagement_tasksStatusChange", (e, data) => {
            let taskIds = data.taskIds
            let workflowStatusId = data.workflowStatusId
            let completed = data.isCompleted

            for (let i = 0; i < taskIds.length; ++i)
                this._changeTaskStatusButton(taskIds[i], workflowStatusId, completed)
        })

        this.stringTokenizer = new StringTokenizer(StringTokenizer.PUNCTUATORS_FOR_SEARCH)
        $(document).on("taskManagement_tasksTable_tasksSearchField_change", (e, text) => {
            let tokens = this.stringTokenizer.getTokens(text)
            this.tokensHighligter = text && (tokens.length > 0) ? new TokensHighlighter(tokens, this.stringTokenizer.getPunctuators()) : null
        })

        $(document).on("taskManagement_tasksAssignedTo", () => {
            this.updateRows()
        })

        $(document).on("taskManagement_task_updated_in_panel", (e, taskId) => {
            this.updateRow(taskId)
        })

        $(document).on("taskManagement_loadTasks_withReload_begin", () => {
            this.showReloadLoadingMoire()
        })
        $(document).on("taskManagement_loadTasks_withAppend_begin", () => {
            this.showAppendLoadingMoire()
        })

        this.taskStatusMenu = new TaskStatusMenu().init(this.$el)
        this.typeOfWorkMenu = new TypeOfWorkMenu({
            additionalClass: 'tasksTableTypeOfWorkMenu',
        }).init(this.$el)

        this.customFieldDropDownMenu = new DropdownOptionsMenu({}).init(this.$el)
    }

    addNewCreatedTaskRow(taskId) {
        this.taskRows[taskId] = new TaskRow({
            taskId: taskId,
            tokensHighlighter: this.tokensHighligter,
            openTaskPanel: this.actions.openTaskPanel,
            typeOfWorkMenu: this.typeOfWorkMenu,
            taskStatusMenu: this.taskStatusMenu,
            customFieldDropDownMenu: this.customFieldDropDownMenu,
            onCustomFieldChange: this.actions.updateTaskCustomField,
        }).init(this.$createdTaskRowsTable)
    }

    clearTasksSelection() {
        _.each(this.taskRows, row => row.setSelection(false))
    }

    setTasksSelected(selectedTaskIds) {
        _.each(this.taskRows, (row, id) => {
            row.taskSelectionLabel.setDisabled(false)
            row.setSelection(!!selectedTaskIds[id])
        })
    }

    clearRows() {
        Object.values(this.taskRows).forEach(row => {
            row.clear()
        })
        this.$taskRowsTable.empty()
        this.$createdTaskRowsTable.empty()
        this.taskRows = {}
    }

    removeRows(ids) {
        for (let i = 0; i < ids.length; ++i)
            this.removeRow(ids[i])
    }

    removeRow(taskId) {
        if (_.isUndefined(this.taskRows[taskId]))
            return

        this.taskRows[taskId].fadeOut()
        this.taskRows[taskId].clear()
        this.taskRows[taskId].$el.remove()
        delete this.taskRows[taskId]
    }

    isTaskRowsEmpty() {
        return _.isEmpty(this.taskRows)
    }

    updateRow(taskId) {
        const taskRow = this.taskRows[taskId]
        if (taskRow)
            taskRow.update()
    }

    updateRows() {
        _.each(this.taskRows, row => row.update())
    }

    appendTaskRows(taskIds, updateExisting) {
        this._updateTaskRowsInContainer(taskIds, this.$taskRowsTable, updateExisting)
    }

    appendCreatedTaskRows(taskIds, updateExisting) {
        this._updateTaskRowsInContainer(taskIds, this.$createdTaskRowsTable, updateExisting)
    }

    showReloadLoadingMoire() {
        this.reloadLoadingMoire.show()
    }

    showAppendLoadingMoire() {
        this.appendLoadingMoire.show()
    }

    hideLoadingMoires() {
        this.appendLoadingMoire.hide()
        this.reloadLoadingMoire.hide()
    }

    _changeTaskStatusButton(taskId, workflowStatusId, completed) {
        if (_.isUndefined(this.taskRows[taskId]))
            return

        this.taskRows[taskId].setState({
            workflowStatusId: workflowStatusId,
            completed: completed,
        })
    }

    _updateTaskRowsState() {
        _.each(this.taskRows, taskRow => this._updateTaskRowState(taskRow))
    }

    _updateTaskRowState(taskRow) {
        const task = TaskStore.get(taskRow.taskId)
        const canEdit = this.state.canEditHierarchy && !!this.state.manageableTaskIds[task.id]

        taskRow.setState({
            canEdit,
            canEditTypeOfWork: canEdit || (this.state.canGenerateMoneyReports && !!this.state.manageableTaskIds[task.id]),
            canReopenProject:  !this.state.archivedProjectIds[task.projectId] ||
                               (!!this.state.editableProjectIds[task.projectId] && !this.state.archivedCustomerIds[task.customerId]) ||
                              !!this.state.editableCustomerIds[task.customerId],
            selectable: this.state.showSelection,
            columnsOrder: this.state.columnsOrder,
            isTWSEnabled: this.state.isTWSEnabled,
            isBTYEnabled: this.state.isBTYEnabled,
            isESTEnabled: this.state.isESTEnabled,
            singleCPSelection: this.state.singleCustomerProjectSelection,
            customFields: this.state.customFields,
        })

        taskRow.update()
    }

    _updateTaskRowsInContainer(taskIds, $container, updateExisting) {
        _.each(taskIds, (taskId) => {
            if (!this.taskRows[taskId]) {
                this.taskRows[taskId] = new TaskRow({
                    taskId: taskId,
                    tokensHighlighter: this.tokensHighligter,
                    openTaskPanel: this.actions.openTaskPanel,
                    typeOfWorkMenu: this.typeOfWorkMenu,
                    taskStatusMenu: this.taskStatusMenu,
                    customFieldDropDownMenu: this.customFieldDropDownMenu,
                    onCustomFieldChange: this.actions.updateTaskCustomField,
                }).init($container)
            }
        else if (updateExisting)
                this.taskRows[taskId].update()

            this._updateTaskRowState(this.taskRows[taskId])
        }, this)
    }
}

export default connect(
    (state) => ({
        archivedProjectIds: getArchivedProjectIds(state),
        archivedCustomerIds: getArchivedCustomerIds(state),
        manageableTaskIds: getManageableTaskIds(state),
        editableProjectIds: getEditableProjectIds(state),
        editableCustomerIds: getEditableCustomerIds(state),
        showSelection: isNeedToShowSelection(state),
        columnsOrder: getShownColumnsWithOrder(state),
        isTWSEnabled: isTWSEnabled(state),
        isBTYEnabled: isBTYEnabled(state),
        isESTEnabled: isESTEnabled(state),
        canEditHierarchy: canEditHierarchy(state),
        canGenerateMoneyReports: canGenerateMoneyReports(state),
        singleCustomerProjectSelection: getSingleCPSelection(state),
        customFields: getTaskCustomFieldsMap(state),
    }),
    (dispatch) => ({
        openTaskPanel: bindActionCreators(openEditTaskPanel, dispatch),
        updateTaskCustomField: bindActionCreators(updateTaskCustomField, dispatch)
    })
)(TaskRowsTableContent)


// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/TaskRowsTableContent.js